import merge from 'lodash/merge';
import nestDeep from './nestDeep';

/**
 * importTranslations builds and returns a nested object of translation keys
 * from the files found in the context provided to 'ctx'.
 * Keys are automatically nested under the structure as the relative file path
 * and the nesting in the file itself.
 *
 * @param {require.context} ctx The require.context() generated by webpack
 *
 * @param {Boolean} includeFileName Whether the filename should also be in the nesting path
 *
 * @returns {Object}
 * Object of translation keys for the provided context.
 */

export default function(ctx, includeFileName = false) {
  const target = {};
  ctx.keys().forEach(fileName => {
    const path = fileName
      .replace(/\.\w+$/, '') // remove trailing extension
      .replace(/\.\//, '') // remove leading relative path marker
      .split('/'); // convert path to array of names
    if (!includeFileName) {
      path.splice(-1, 1);
    } // strip filename

    const nested = nestDeep(path, ctx(fileName));
    merge(target, nested);
  });
  return target;
}
